import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { BarChart3 } from "lucide-react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../../components/ui/tabs";
import { ReportBuilder } from "../../components/ReportBuilder";
import { FinancialStanding } from "../../components/FinancialStanding";
import { ExpenseLedger } from "../../components/ExpenseLedger";
import { Reconciliation as BankReconciliation } from "../../components/Reconciliation";
import { BudgetVsActual } from "../../components/BudgetVsActual";

const TABS = [["overview", "Overview"], ["expenses", "Expenses"], ["reconciliation", "Bank reconciliation"], ["budget", "Budget"], ["reports", "Reports"]];

export default function FinanceModule() {
  const [params, setParams] = useSearchParams();
  const tab = TABS.some(([k]) => k === params.get("tab")) ? params.get("tab") : "overview";
  return (
    <div data-testid="finance-module">
      <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
        <div><p className="eyebrow text-gold">Officer console</p>
          <h1 className="font-serif-display text-4xl font-bold text-crimson">Finance</h1>
          <p className="text-muted-foreground">Expenses, bank reconciliation and budget — the association's full financial picture.</p></div>
        <Link to="/admin/finance" className="inline-flex min-h-[40px] items-center gap-1 text-sm font-semibold text-palm hover:underline" data-testid="finance-open-reports"><BarChart3 size={15} /> Finance & Reports</Link>
      </div>
      <Tabs value={tab} onValueChange={(v) => setParams({ tab: v })}>
        <TabsList className="mb-6 h-auto flex-wrap justify-start gap-1">
          {TABS.map(([k, label]) => <TabsTrigger key={k} value={k} data-testid={`finance-tab-${k}`}>{label}</TabsTrigger>)}
        </TabsList>
        <TabsContent value="overview"><FinancialStanding /></TabsContent>
        <TabsContent value="expenses"><ExpenseLedger /></TabsContent>
        <TabsContent value="reconciliation"><BankReconciliation /></TabsContent>
        <TabsContent value="budget"><BudgetVsActual /></TabsContent>
        <TabsContent value="reports"><ReportBuilder /></TabsContent>
      </Tabs>
    </div>
  );
}
